<ion-header>
  <ion-toolbar>
    <ion-title>Sentiment model inferencing</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="closeModal()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="no-hover-page" [fullscreen]="true">
  <form [formGroup]="addTextForm" (ngSubmit)="onSubmit()" class="ion-padding" style="margin-top: 55px;">
    <ion-card class="form-card">
      <ion-card-content>
          <ion-item class="form-item">
            <ion-label position="stacked">Text</ion-label>
            <ion-input formControlName="message" placeholder="Enter your text"></ion-input>
          </ion-item>

          <ion-item class="form-item">
            <ion-label position="stacked">Language</ion-label>
            <ion-select formControlName="lang" placeholder="Select language">
              <ion-select-option value="nl">Dutch</ion-select-option>
              <ion-select-option value="en">English</ion-select-option>
            </ion-select>
          </ion-item>
      </ion-card-content>
    </ion-card>

    <ion-button class="submit-button" expand="block" type="submit" [disabled]="addTextForm.invalid">Submit</ion-button>
  </form>
</ion-content>


